import { render } from "./PostNews.vue?vue&type=template&id=70a99da1&scoped=true"
import script from "./PostNews.vue?vue&type=script&lang=js"
export * from "./PostNews.vue?vue&type=script&lang=js"

import "./PostNews.vue?vue&type=style&index=0&id=70a99da1&lang=scss&scoped=true"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a99da1"]])

export default __exports__